import axios from "axios";
import { baseUrl } from "../util";

// Get LCA Phase Selection
export const getLCAPhaseSelection = ({
  productId,
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/lca-phase-selection`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching LCA phase selection:", error);
      setData(null);
    });
};

// Update LCA Phase Selection
export const updateLCAPhaseSelection = ({
  productId,
  lca_phases,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/lca-phase-selection`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      lca_phases: lca_phases || {},
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "LCA phase selection updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating LCA phase selection:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update LCA phase selection",
          icon: "error",
          button: "OK",
        });
      }
    });
};




